import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../app/routes/routes';

export function NotFoundPage() {
	const navigate = useNavigate();

	return (
		<Container
			h="100vh"
			style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
			size="sm"
			py="xl"
		>
			<Stack gap="xl" align="center" ta="center">
				<Title order={1}>404</Title>
				<Title order={2}>Page Not Found</Title>
				<Text c="dimmed" size="lg">
					The page you&apos;re looking for doesn&apos;t exist or has been moved.
				</Text>
				<Button onClick={() => navigate(routes.dashboard)}>Go to Dashboard</Button>
			</Stack>
		</Container>
	);
}
